import { shouldUseChecklistTemplatesV2 } from "../../../domain/checklist_template_version.policy";

export default function ChecklistTemplateMigrationService(
    $q,
    $log,
    $sbCurrentProject,
    $sbChecklistTemplateWebService
) {
    "ngInject";

    var QA2_ADDON_CODE = "QA2";

    return {
        shouldUseNewChecklistTemplatesPage: shouldUseNewChecklistTemplatesPage,
    };

    // Evaluated fresh on every call, no result caching.
    function shouldUseNewChecklistTemplatesPage() {
        var projectId = $sbCurrentProject.get().id;
        var hasQa2AddOn = _hasQa2AddOn();

        if (!hasQa2AddOn) {
            return $sbChecklistTemplateWebService
                .getByProjectV2(projectId)
                .then(function (v2Response) {
                    return shouldUseChecklistTemplatesV2(false, {
                        hasV1ChecklistTemplates: false,
                        hasV2ChecklistTemplates: _hasTemplates(v2Response),
                    });
                });
        }

        return $q
            .all([
                $sbChecklistTemplateWebService.getByProject(projectId),
                $sbChecklistTemplateWebService.getByProjectV2(projectId),
            ])
            .then(function (results) {
                var hasV1Templates = _hasTemplates(results[0]);
                var hasV2Templates = _hasTemplates(results[1]);
                var shouldUseNewPage = shouldUseChecklistTemplatesV2(true, {
                    hasV1ChecklistTemplates: hasV1Templates,
                    hasV2ChecklistTemplates: hasV2Templates,
                });

                $log.debug("[ChecklistTemplateMigration] eligibility check", {
                    projectId: projectId,
                    hasQa2AddOn: hasQa2AddOn,
                    hasV1Templates: hasV1Templates,
                    hasV2Templates: hasV2Templates,
                    shouldUseNewPage: shouldUseNewPage,
                });

                return shouldUseNewPage;
            });
    }

    function _hasTemplates(response) {
        return !!(response && response.checklist_templates.length > 0);
    }

    function _hasQa2AddOn() {
        var subscription = $sbCurrentProject.get().subscription || "";
        return subscription.split(",").indexOf(QA2_ADDON_CODE) > -1;
    }
}
